import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

// Import all components
import App from './App';
import { SmartAgentWebComponent } from './web-component/SmartAgentWebComponent';

// Global API
declare global {
  interface Window {
    SmartAgent: {
      init: (config: any, container?: HTMLElement) => void;
      create: (config: any) => HTMLElement;
      version: string;
    };
  }
}

// Create global SmartAgent object
window.SmartAgent = {
  version: '1.0.0',
  
  // Method 1: Initialize in a container or create new one
  init: (config, container) => {
    if (!container) {
      container = document.createElement('div');
      document.body.appendChild(container);
    }
    
    const root = createRoot(container);
    root.render(
      React.createElement(App, {
        initialTheme: config.theme || 'dark',
        initialColor: config.primaryColor || '#2563eb'
      })
    );
  },

  // Method 2: Create web component programmatically
  create: (config) => {
    const element = document.createElement('smart-agent');
    Object.entries(config).forEach(([key, value]) => {
      const attr = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      if (typeof value === 'boolean') {
        if (value) element.setAttribute(attr, '');
      } else {
        element.setAttribute(attr, String(value));
      }
    });
    return element;
  }
};

// Auto-register web component
if (!customElements.get('smart-agent')) {
  customElements.define('smart-agent', SmartAgentWebComponent);
}